import React, { useEffect, useMemo, useState } from "react"
import { DataGrid } from "@mui/x-data-grid"
import {
  Card,
  CardBody,
  Input,
  CardFooter,
  Button,
  Autocomplete,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
  Chip,
  Select,
  AutocompleteItem,
  Table, TableHeader, TableColumn, TableBody, TableRow, TableCell,
  SelectItem
} from "@nextui-org/react"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrash } from "@fortawesome/free-solid-svg-icons"
import { calculateTotal } from "../../Utility/utility"
import MainContainer from "../../components/MainContainer.jsx"
import { useDispatch, useSelector } from "react-redux"
import { apiRoute, funValidateNoInput, linksUrl } from "../../constants/enum"
import { useNavigate } from "react-router-dom"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import {
  resetValues,
} from "../../state/creditDebitNoteSlice"
import dayjs from "dayjs"
import {
  ENUM_CRDRNOTE_TYPE,
  ENUM_INVOICE_TYPE,
  ENUM_NOTE_TYPE,
  ENUM_SUPPLY_TYPE,
  ENUM_ROWS_FIELD,
  ENUM_INITIALROW,
  fun_calTcs_Amt,
  fun_calTotalTax,
  fun_calTds_Amt,
  fun_calNet_Amt,
  ENUM_TRADE_TYPE,
} from "./enum.js"
import { toast } from "react-toastify"
import ErrorCard from "../../components/ErrorCard.jsx"
import { isMobile } from 'react-device-detect';
import LoadingCard from "../../components/LoadingCard.jsx"



function CreditDebitNote() {
  const { detailParams, isCreditNote, isNewEntry } = useSelector(
    (state) => state.cerditDebitNote
  )
  let { compCode, compState, isMultipleCompany, startDate, endDate } = useSelector((state) => state.company)
  let { user } = useSelector((state) => state.auth)
  let [deletedItemRows, setDeletedItemRows] = useState([])
  const [selectedBillNo, setSelectedBillNo] = useState("");
  const [selectedBillRowNo, setSelectedBillRowNo] = useState("");
  let dispatch = useDispatch()
  let gridData = []
  const {
    isOpen: isOpenReportModel,
    onOpen: onOpenReportModel,
    onOpenChange: onOpenReportModelChange,
  } = useDisclosure();
  const [rows, setRows] = useState([])
  const [JvTrnData, setJvTrnData] = useState({
    trnNo: 0,
    tdsJvTrnNo: 0,
    tcsJvTrnNo: 0,
    excJvTrnNo: 0,
    excSedJvTrnNo: 0,
    excAedJvTrnNo: 0,
  })
  let [formData, setFormData] = useState({
    transId: 0,
    type: "",
    supplyType: "",
    noteType: "",
    vouNo: "",
    docDate: new Date(),
    noteNo: "",
    partyDocNo: "",
    debitAc: "",
    creditAc: "",
    tradeType: "",
    tdsAc: "",
    remarks: "",
    debitAcName: "",
    creditAcName: ""
  })
  const hanldeBillNo = (rowid) => {
    if ((formData?.debitAc != "" || formData.creditAc != "") && rows[rowid].acYear != "0" && rows[rowid].invType != "") {

      // if (selectedBillRowNo && selectedBillRowNo != "" && Number(selectedBillRowNo) != Number(rowid)) {
      // console.log("0",rows[selectedBillRowNo]?.acYear,"n",rows[rowid]?.acYear)
      funFillBillNo(rows[rowid].invType, formData.creditAc, formData.debitAc, formData.noteType, rows[rowid].acYear)
      // }
      setSelectedBillRowNo(rowid)
      onOpenReportModel();
    }
    else {
      toast.error("Select  invoice type And Debit/Credit  A/c ", {
        position: "top-center"
      })
    }

  }

  //console.log(selectedBillNo, selectedBillRowNo)
  const handleBillNoChange = (e) => {
    const val = Array.from(e)[0]
    const newRows = [...rows]
    newRows[selectedBillRowNo].invNo = val
    setSelectedBillNo(val)
    setRows(newRows)
  }
  //console.log(rows)
  const reportModel = (id) => {
    return (
      <div>
        <Modal
          isOpen={isOpenReportModel}
          onOpenChange={onOpenReportModelChange}
          size="md"
          placement="center"
          scrollBehavior="inside"
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="flex  border-2 border-b-rose-400  uppercase text-sky-700 font-bold text-sm">
                  Invoice
                </ModalHeader>
                <ModalBody className="p-2">
                  <Table
                    selectionMode="single"
                    color={"success"}
                    isHeaderSticky
                    selectedKeys={[String(selectedBillNo)]}
                    onSelectionChange={(e) => handleBillNoChange(e)}
                    aria-label="Invoice Details"
                  >
                    <TableHeader>
                      <TableColumn className="bg-sky-700 text-white text-center" >BILL NO</TableColumn>
                      <TableColumn className="bg-sky-700 text-white text-center">DATE</TableColumn>
                      <TableColumn className="bg-sky-700 text-white text-center">AMOUNT</TableColumn>
                    </TableHeader>
                    <TableBody>
                      {
                        billNoData && billNoData.length > 0 &&
                        billNoData.map((ele) => {
                          return (
                            <TableRow className="border-1" key={ele.BILL_NO}>
                              <TableCell>{ele?.BILL_NO}</TableCell>
                              <TableCell>{ele?.BILL_DATE}</TableCell>
                              <TableCell>{ele?.NETAMT}</TableCell>
                            </TableRow>
                          )
                        })
                      }
                    </TableBody>
                  </Table>
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    );
  };
  const { isPending: isLoadingDetail, isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
    url: apiRoute.transaction.creditdebitnote.fetchInvoiceDetail,
    queryKey: "crdrnoteEntryDetail",
  })

  useEffect(() => {

    if (startDate && startDate != "" && startDate != null && endDate && endDate != "" && endDate != null) {
      if (isMultipleCompany)
        navigate(linksUrl.dashboard.tradingDashboard)

      if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {

        const { comp_code, transaction_id } = detailParams
        funGetDetail({
          data: {
            compcode: comp_code,
            transactionid: transaction_id,
          }
        })
      }
    }
  }, [startDate, endDate])

  if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
    if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {

      gridData = detail?.itemDetail.map((item, i) => {
        return {
          id: ++i,
          acYear: item?.ac_year ?? 1,
          invType: item?.bill_type ?? "",
          invNo: item?.bill_no ?? "",
          itemName: item?.item_code ?? "",
          printDetail: item?.item_det ?? "",
          qty: item?.nos ?? 0,
          rate: item?.rate ?? 0,
          amount: item?.amount ?? 0,
          discPer: item?.discper ?? 0,
          discAmt: item?.discamt ?? 0,
          stPer: item?.stper ?? 0,
          stAmt: item?.stamt ?? 0,
          astPer: item?.astper ?? 0,
          astAmt: item?.astamt ?? 0,
          netAmt: item?.amount
            ? fun_calNet_Amt(item.amount, item?.discamt, item?.stamt, item?.astamt)
            : 0,
          detailId: item?.detailid ?? 0,
        }
      })
    }
  }

  const funSetTradeType = (partyId) => {
    if (partyId != "" && partyId != null) {
      let t_tradeType = formData.tradeType
      if (compState && compState?.trim() != "") {
        const tempData = masterData.accountMaster.filter((ele) => ele.Party_Id == partyId)

        if (tempData && tempData?.length > 0) {
          if (tempData[0]?.ADD_6.trim() != "") {
            if (tempData[0]?.ADD_6.trim().toLowerCase() == compState?.trim().toLowerCase())
              t_tradeType = "RD"
            else
              t_tradeType = "OGS"
          }
          else
            t_tradeType = "URD"
        }
        if (t_tradeType == "URD" || t_tradeType == "RD") setIsStPerDisable(false)
        else setIsStPerDisable(true)
      }
      return t_tradeType
    }
    else
      return ""
  }


  let [setTcsPer, setSetTcsPer] = useState(0)
  let [setTdsPer, setSetTdsPer] = useState(0)

  const SUPPLY_TYPE = ENUM_SUPPLY_TYPE
  const NOTE_TYPE = ENUM_NOTE_TYPE
  const TRADE_TYPE = ENUM_TRADE_TYPE
  const INVOICE_TYPE = ENUM_INVOICE_TYPE
  const CRDRNOTE_TYPE = ENUM_CRDRNOTE_TYPE

  const { isLoading, data: masterData = [] } = useFetchWithBody({
    url: apiRoute.transaction.creditdebitnote.fetchMasterData,
    queryKey: "getCreditMasterData",
    inputData: {
      comp_code: compCode.join(","),
    },
  })

  console.log(detail, "fg")
  useEffect(() => {
    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0)
      setRows(gridData)
    if (
      !isNewEntry &&
      isCreditNote &&
      detail &&
      detail?.itemData &&
      detail?.itemData.length > 0
    ) {

      setSetTcsPer(detail.itemData[0].tcsper)
      setSetTdsPer(detail.itemData[0].tdsper)
      if (detail.itemData[0]?.trade_type == "URD" || detail.itemData[0]?.trade_type == "RD") setIsStPerDisable(false)
      else setIsStPerDisable(true)

      setJvTrnData({
        trnNo: detail?.itemData[0]?.trn_no ?? 0,
        tdsJvTrnNo: detail?.itemData[0]?.tdsjvtrnno ?? 0,
        tcsJvTrnNo: detail?.itemData[0]?.tcsjvtrnno ?? 0,
        excAedJvTrnNo: detail?.itemData[0]?.excaedjvtrnno ?? 0,
        excSedJvTrnNo: detail?.itemData[0]?.excsedjvtrnno ?? 0,
        excJvTrnNo: detail?.itemData[0]?.excjvtrnno ?? 0
      })
      funFillBillNo(gridData[0]?.invType, detail.itemData[0]?.credit_account_id, detail.itemData[0]?.debit_account_id, detail.itemData[0]?.entry_type, gridData[0]?.acYear)
      setSelectedBillNo(gridData[0]?.invNo)
      setSelectedBillRowNo(0)

      setFormData({
        type: detail.itemData[0]?.doc_for ?? "",
        supplyType: detail.itemData[0]?.supply_type ?? "",
        noteType: detail.itemData[0]?.entry_type ?? "",
        vouNo: detail.itemData[0]?.vou_no ?? "",
        docDate: detail.itemData[0]?.bill_date ?? "",
        noteNo: detail.itemData[0]?.bill_no ?? "",
        partyDocNo: detail.itemData[0]?.chal_no ?? "",
        debitAc: detail.itemData[0]?.debit_account_id ?? "",
        creditAc: detail.itemData[0]?.credit_account_id ?? "",
        tradeType: detail.itemData[0]?.trade_type ?? "",
        tdsAc: detail.itemData[0]?.tds_account_id ?? "",
        remarks: detail.itemData[0]?.remark ?? "",
        creditAcName: detail.itemData[0]?.credit_account_name ?? "",
        debitAcName: detail.itemData[0]?.debit_account_name ?? ""
      })
    } //set data on edit
  }, [detail])

  let navigate = useNavigate()
  let [isStPerDisable, setIsStPerDisable] = useState(false)


  const RowsField = ENUM_ROWS_FIELD
  //set name for rows column (field)

  let initialRow = ENUM_INITIALROW

  //fn to calculation of total tax section
  const total_disc = useMemo(
    () =>
      calculateTotal({
        data: rows,
        columnName: "discAmt",
      }),
    [rows]
  )
  const total_GSTtax = useMemo(
    () =>
      calculateTotal({
        data: rows,
        columnName: "stAmt",
      }),
    [rows]
  )
  const total_SGSTtax = useMemo(
    () =>
      calculateTotal({
        data: rows,
        columnName: "astAmt",
      }),
    [rows]
  )
  const gross_Amount = useMemo(
    () =>
      calculateTotal({
        data: rows,
        columnName: "amount",
      }),
    [rows]
  )
  const net_Amount = useMemo(
    () =>
      calculateTotal({
        data: rows,
        columnName: "netAmt",
      }),
    [rows]
  )
  const funSetGst = (newRows, itemCode, index, tradeType) => {
    const tempData = masterData.itemMaster.filter((ele) => ele.Item_Code.toLowerCase() == itemCode.toLowerCase())
    //console.log(tempData,tempData?.length)
    if (tempData) {
      if (tempData.length > 0) {
        const t_StPer = Number(tempData[0]?.STPer);
        const t_AstPer = Number(tempData[0]?.ASTPer)
        if (tradeType == "OGS") {
          newRows[index].stPer = t_StPer + t_AstPer
          newRows[index].astPer = 0;
        }
        else {
          newRows[index].astPer = t_AstPer;
          newRows[index].stPer = t_StPer;
        }
        let tempTot = 0;
        tempTot =
          ((newRows[index].amount - newRows[index].discAmt) *
            t_StPer) /
          100
        newRows[index].stAmt = tempTot

        tempTot =
          ((newRows[index].amount - newRows[index].discAmt) *
            t_AstPer) /
          100
        newRows[index].astAmt = tempTot

        tempTot = fun_calNet_Amt(
          newRows[index].amount,
          newRows[index].discAmt,
          newRows[index].stAmt,
          newRows[index].astAmt
        )
        newRows[index].netAmt = tempTot
      }
    }
    setRows(newRows)
    // return newRows
  }
  const total_Tax = useMemo(() => fun_calTotalTax(total_GSTtax, total_SGSTtax), [rows])
  const total_TdsAmt = useMemo(() => fun_calTds_Amt(gross_Amount, setTdsPer), [rows, setTdsPer])
  const total_TcsAmt = useMemo(() => fun_calTcs_Amt(net_Amount, setTcsPer), [rows, setTcsPer])
  // end fn to calculation of total tax section

  const { data: billNoData, mutate: filterBillno } = usePost({
    url: apiRoute.transaction.creditdebitnote.fetchBillNo,
    queryKey: "fetchbillNopartywise"
  })

  const funFillBillNo = (billType, creditAcId, debitAcid, noteType, acYear) => {
    //console.log(billType, creditAcId, debitAcid, noteType, acYear)
    let t_BillType = billType
    let t_AcYear = acYear
    let t_noteType = noteType

    if (noteType == "") {
      if (debitAcid && debitAcid != "")
        t_noteType = "DEBIT"
      if (creditAcId && creditAcId != "")
        t_noteType = "CREDIT"
    }

    if ((billType == "" || (acYear == "0" || acYear == "")) && rows && rows.length > 0) {
      t_BillType = rows[0]?.invType ?? ""
      t_AcYear = rows[0]?.acYear ?? 1
    }

    if (t_BillType != "" && t_noteType != "") {
      filterBillno({
        data: {
          comp_code: compCode.join(","),
          bill_type: String(t_BillType),
          ac_year: Number(t_AcYear),
          credit_acid: t_noteType && t_noteType == "CREDIT" ? creditAcId ?? "" : "",
          debit_acid: t_noteType && t_noteType == "DEBIT" ? debitAcid ?? "" : ""

        }
      })
    }
  }
  const handleSelectChange = (event, index, type) => {

    const newRows = [...rows]
    if (type == "invType") {
      newRows[index].invType = event
      funFillBillNo(event, formData.creditAc, formData.debitAc, formData.noteType, newRows[index].acYear)
    }

    else if (type == "itemName") {
      newRows[index].itemName = event
      funSetGst(newRows, event, index, formData.tradeType)
    }
    else if (type == "invNo") {
      newRows[index].invNo = event
      setSelectedBillNo(event)
    }

    setRows(newRows)
  }
  const handleClickPrev = () => {
    dispatch(resetValues)
    navigate(linksUrl.transaction.creditDebitEntry.invoicedatalist)
  }
  const funUpdateItemGst = (val) => {
    let newRows = [...rows]
    rows.map((element, index) => {
      funSetGst(newRows, element.itemName, index, val)
    })
  }

  //set tax calculation on value input
  const handleInputChange = (index, e) => {
    let { value, id } = e.target

    const newRows = [...rows]

    if (id == RowsField.acYear) {
      newRows[index].acYear = value
      funFillBillNo(newRows[index].invType, formData.creditAc, formData.debitAc, formData.noteType, value)

    }
    else if (id == RowsField.invNo) newRows[index].invNo = value
    else if (id == RowsField.itemName) newRows[index].itemName = value
    else if (id == RowsField.printDetail) newRows[index].printDetail = value
    else if (id == RowsField.qty) newRows[index].qty = value
    else if (id == RowsField.rate) newRows[index].rate = value
    else if (id == RowsField.amount) newRows[index].amount = value
    else if (id == RowsField.discPer) newRows[index].discPer = value
    else if (id == RowsField.discAmt) newRows[index].discAmt = value
    else if (id == RowsField.stPer) newRows[index].stPer = value
    else if (id == RowsField.stAmt) newRows[index].stAmt = value
    else if (id == RowsField.astPer) newRows[index].astPer = value
    else if (id == RowsField.astAmt) newRows[index].astAmt = value
    else if (id == RowsField.netAmt) newRows[index].netAmt = value
    let tempTot = 0
    if (
      id == RowsField.rate ||
      id == RowsField.qty ||
      id == RowsField.discPer ||
      id == RowsField.stPer ||
      id == RowsField.astPer
    ) {
      tempTot = newRows[index].rate * newRows[index].qty
      newRows[index].amount = tempTot

      tempTot = (newRows[index].amount * newRows[index].discPer) / 100
      newRows[index].discAmt = tempTot

      tempTot =
        ((newRows[index].amount - newRows[index].discAmt) *
          newRows[index].stPer) /
        100
      newRows[index].stAmt = tempTot

      tempTot =
        ((newRows[index].amount - newRows[index].discAmt) *
          newRows[index].astPer) /
        100
      newRows[index].astAmt = tempTot

      tempTot = fun_calNet_Amt(
        newRows[index].amount,
        newRows[index].discAmt,
        newRows[index].stAmt,
        newRows[index].astAmt
      )
      newRows[index].netAmt = tempTot
    }
    setRows(newRows)
  }
  //end set tax calculation on value input
  // dynamic grid column
  const renderInputCell = (row, input_id, input_type, is_readonly, holder_text, is_required) => {

    return (
      <Input
        isRequired={is_required}
        id={RowsField[input_id]}
        type={input_type}
        size="sm"
        // label=""
        labelPlacement="outside"
        variant="bordered"
        isDisabled={input_id == "astPer" ? isStPerDisable : is_readonly}
        placeholder={holder_text}
        //allow space in text box
        onKeyDown={(event) => {
          if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
            return; // Do nothing
          } else {
            event.stopPropagation(); // Prevent other keys from propagating
          }
        }}
        defaultValue=""
        value={
          input_id == "astPer" || input_id == "astAmt"
            ? isStPerDisable
              ? "0"
              : row[input_id]
            : row[input_id]
        }
        onChange={(e) => handleInputChange(row.id - 1, e)}
        className="max-w-xs mt-2"
      ></Input>
    )
  }
  const itemGridHeadClass = "item-grid-style"

  const columns = [
    {
      field: RowsField.id,
      headerName: "Delete",
      width: 60,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,

      renderCell: (params) => (
        <strong>
          <FontAwesomeIcon
            color="red"
            onClick={() => handleDeleteRow(params.row.id)}
            icon={faTrash}
          ></FontAwesomeIcon>
        </strong>
      ),
    },
    {
      field: RowsField.acYear,
      headerName: "Ac.Year",
      width: 80,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.acYear, "text", false, "Ac.Year", true),
    },

    {
      field: RowsField.invType,
      headerName: "Inv.Type",
      width: 120,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <Select
          isRequired
          id={RowsField.invType}
          size="sm"
          items={INVOICE_TYPE ? INVOICE_TYPE : []}
          // label="inv.Type"
          isVirtualized
          placeholder="Invoice Type"
          value={row.invType}
          className="max-w-xs mt-2"
          variant="flat"
          color="primary"
          selectedKeys={[String(row.invType)]}
          onChange={(event) =>
            handleSelectChange(event.target.value, row.id - 1, "invType")
          }
        >
          {(INVOICE_TYPE) => {
            return (
              <SelectItem key={INVOICE_TYPE.value}>
                {INVOICE_TYPE.label}
              </SelectItem>
            )
          }}
        </Select>
      ),
    },
    {
      field: RowsField.invNo,
      headerName: "Inv No",
      width: 210,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (

        <div className="flex items-center gap-2">
          <Chip size="sm" color="danger" radius="sm" className="ml-3 mt-2 cursor-pointer" variant="shadow" onClick={() => hanldeBillNo(row.id - 1)}>
            View</Chip>
          <Input
            //isRequired
            id={RowsField.invNo}
            type="text"
            size="sm"

            placeholder="Inv No"
            defaultValue=""
            value={row.invNo}
            variant="flat"
            color="success"
            onChange={(e) => handleInputChange(row.id - 1, e)}
            className="max-w-28 mt-2"
          ></Input>

        </div>
      )
    },
    {
      field: RowsField.itemName,
      headerName: "Item Name",
      width: 180,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <Autocomplete
          isRequired
          id={RowsField.itemName}
          size="sm"
          defaultItems={
            masterData && masterData.itemMaster ? masterData.itemMaster : []
          }
          isVirtualized
          placeholder="Item Name"
          value={row.itemName}
          variant="flat"
          color="warning"
          className="max-w-xs"
          selectedKey={row.itemName}
          onSelectionChange={(event) =>
            handleSelectChange(event, row.id - 1, "itemName")
          }
        >
          {(item) => (
            <AutocompleteItem key={item.Item_Code}>
              {item.Item_Desc}
            </AutocompleteItem>
          )}
        </Autocomplete>
      ),
    },
    {
      field: RowsField.printDetail,
      headerName: "Detail To Print",
      width: 150,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.printDetail, "text", false, "Detail", false),
    },

    {
      field: RowsField.qty,
      headerName: "QTY",
      width: 120,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.qty, "number", false, "", true),
    },
    {
      field: RowsField.rate,
      headerName: "Rate",
      width: 120,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.rate, "number", false, "", true),
    },
    {
      field: RowsField.amount,
      headerName: "Amount",
      width: 130,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.amount, "number", true, "", true),
    },
    {
      field: RowsField.discPer,
      headerName: "Disc %",
      width: 85,
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.discPer, "number", false, "", false),
    },
    {
      field: RowsField.discAmt,
      headerName: "Disc Amount",
      width: 100,
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.discAmt, "number", true, "", false),
    },
    {
      field: RowsField.stPer,
      headerName: !isStPerDisable ? "CGST %" : "IGST %",
      width: 85,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.stPer, "number", false, "", false),
    },
    {
      field: RowsField.stAmt,
      headerName: !isStPerDisable ? "CGST" : "IGST",
      headerClassName: itemGridHeadClass,
      width: 120,
      headerAlign: "center",
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.stAmt, "number", true, "", false),
    },
    {
      field: RowsField.astPer,
      headerName: "SGST%",
      width: 85,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.astPer, "number", false, "", false),
    },
    {
      field: RowsField.astAmt,
      headerName: "SGST",
      width: 120,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.astAmt, "number", true, "", false),
    },
    {
      field: RowsField.netAmt,
      headerName: "Net Amount",
      width: 150,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) =>
        renderInputCell(row, RowsField.netAmt, "number", true, "", false),

    },
  ]
  //end dynamic grid column
  //to add new row in grid
  const handleAddRow = () => {

    const newRow = { id: rows.length + 1, ...initialRow }
    console.log(newRow)
    setRows([...rows, newRow])
  }
  //end add new row in dynamic grid

  //delete row from dynamic grid
  const handleDeleteRow = (id) => {
    const updatedRows = rows.filter((row) => row.id !== id)
    let DeletedRow = rows.filter((row) => row.id == id)
    setRows(updatedRows)
    setDeletedItemRows([...deletedItemRows, ...DeletedRow])
  }

  //end delete row from dynamic grid

  const onSuccessTasks = (data) => {
    navigate(linksUrl.transaction.creditDebitEntry.invoicedatalist)
    dispatch(resetValues())
  }


  const resetData = () => {
    setFormData([])
    setRows([])
    setDeletedItemRows([{}])
  }

  const onSuccessVouno = (data) => {
    if (data && data.length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        vouNo: data[0].new_vou_no,
        noteNo: data[0].new_vou_no
      }))
    }
  }
  //get generted vouno
  const { mutate: generateVouNo } = usePost({
    url: apiRoute.transaction.creditdebitnote.generateVouNo,
    queryKey: "generate-vouno",
    onSuccessTasks: onSuccessVouno
  })
  //end
  const {
    isPending,
    isError,
    mutate: insertUpdateCreditNote,
  } = usePost({
    url: apiRoute.transaction.creditdebitnote.add,
    queryKey: "insertNoteMaster",
    onSuccessTasks,
    resetValues: resetData,
  })
  const ValidateGrid = () => {
    //let no = 0
    for (let i = 0; i < rows.length; i++) {
      // no = i + 1
      if (rows[i].qty <= 0 || rows[i].rate <= 0) {
        return 1
      }
    }
  }
  // if (isError) {
  //   return <ErrorCard />
  // }

  //handel form submit
  const handleSubmit = (e) => {
    e.preventDefault()

    if (rows && rows.length > 0) {
      if (!ValidateGrid()) {
        insertUpdateCreditNote({
          data: {
            item_list: rows,
            deleteditem_list: deletedItemRows,
            rec_status: !isNewEntry ? 1 : 2, //
            trans_id: !isNewEntry ? detail.itemData[0]?.TransactionId : 0, //formData.transId,
            comp_code: compCode.join(","),
            debit_ac_id: formData.debitAc,
            credit_ac_id: formData.creditAc,
            doc_type: formData.type,
            vou_no: formData.vouNo,
            entry_type: formData.noteType,
            party_doc_no: formData.partyDocNo,
            doc_date: formData.docDate,
            note_no: formData.noteNo,
            trade_type: formData.tradeType,
            gross_amt: gross_Amount,
            total_gst: total_GSTtax,
            total_sgst: total_SGSTtax,
            disc_amt: total_disc,
            net_amt: net_Amount,
            tds_per: setTdsPer && setTdsPer != "" ? setTdsPer : 0,
            tds_amt: total_TdsAmt,
            tds_acid: formData.tdsAc,
            tcs_per: setTcsPer && setTcsPer != "" ? setTcsPer : 0,
            tcs_amt: total_TcsAmt,
            remark: formData.remarks,
            login_userid: user.username,
            jv_trn_data: JvTrnData,
            fystart_date: dayjs(startDate).format("YYYY-MM-DD"),
            fyend_date: dayjs(endDate).format("YYYY-MM-DD"),
          },
        })
      }
      else {
        toast.error("Enter value for QTY and Rate ", {
          position: "top-center"
        })
      }

    }
    else {
      toast.error("Add Items", {
        position: "top-center"
      })
    }
    // console.log(obj)
  }

  //end form submit
  const handleFormChange = (e) => {
    const { name, value } = e.target

    if (name == "tradeType") {
      if (value == "URD" || value == "RD") setIsStPerDisable(false)
      else setIsStPerDisable(true)

    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))


  }
  // console.log(masterData)
  const handleFormSelectionChange = (e, type) => {

    let val = e;
    let t_tradeType = formData.tradeType

    if (type == "tradeType") {
      if (val == "URD" || val == "RD") setIsStPerDisable(false)
      else setIsStPerDisable(true)

      // funUpdateItemGst(val)
      // t_tradeType=val
      // let newRows = [...rows]
      // rows.map((element, index) => {
      //   funSetGst(newRows, element.itemName, index, val)
      // })

    }
    if (type == "noteType") {
      funFillBillNo("", formData.creditAc, formData.debitAc, val, "")
      if ((formData.creditAc != null && formData.creditAc != "") || (formData.debitAc != null && formData.debitAc != "")) {
        let partyId = ""
        if (val == "CREDIT")
          partyId = formData.creditAc
        else if (val == "DEBIT")
          partyId = formData.debitAc

        t_tradeType = funSetTradeType(partyId)


      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [type]: val,
      tradeType: t_tradeType
    }))

    if (type == "type" || type == "supplyType" || type == "noteType") {

      let paramType = type == "type" ? val.substring(0, 2) : formData.type.substring(0, 2);
      let paramSupplyType = type == "supplyType" ? val : formData.supplyType;
      let paramNoteType = type == "noteType" ? val : formData.noteType

      if (paramType != "" && paramSupplyType != "" && paramNoteType != "") {
        generateVouNo({
          data: {
            compcode: compCode.join(","),
            type: paramType,
            supply_type: paramSupplyType,
            entry_type: paramNoteType,
            start_date: dayjs(startDate).format("YYYY-MM-DD"),
            end_date: dayjs(endDate).format("YYYY-MM-DD")
          }
        })
      }
    }
  }


  const handleAutoCompleteChanged = (value, name) => {

    //let fieldName =  debitAc: "",
    // creditAc: "",
    let t_tradeType = formData.tradeType;

    //if (name == "creditAc") {
    //fieldName = "creditAcName"

    // }
    let t_noteType = formData.noteType ?? ""

    funFillBillNo("", value, value, t_noteType, "")
    if ((t_noteType == "DEBIT" && name == "debitAc") || (t_noteType == "CREDIT" && name == "creditAc")) {

      t_tradeType = funSetTradeType(value)

      funUpdateItemGst(t_tradeType)

    }
    setFormData({
      ...formData,
      [name]: value,
      tradeType: t_tradeType
    })

  }
  if (isLoadingDetail) {
    return <LoadingCard />
  }
  if (isError || isErrorDetail) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer
        pageName={`${isNewEntry ? "New" : "Update"} Credit/Debit Note Entry`}
        info={[]}
        breadcrumbs={["Transaction", "Credit / Debit Note"]}
        prevPage={{
          show: true,
          onClick: handleClickPrev,
        }}
      >
        {reportModel()}
        <Card shadow="sm" radius="sm" className="mb-3 h-full">
          <form onSubmit={handleSubmit} autoComplete="off">
            <CardBody className="p-2">
              {/* credit/debit note form section */}

              <div>
                <div className="flex  items-center gap-2 mb-5">
                  <Autocomplete
                    isRequired
                    size="sm"
                    label="Type"
                    placeholder="Select Type"
                    defaultItems={CRDRNOTE_TYPE ? CRDRNOTE_TYPE : []}
                    className="max-w-23"
                    name="type"
                    isClearable={false}
                    value={formData.type}
                    selectedKey={formData.type}
                    isVirtualized
                    // onChange={handleFormSelectionChange}
                    onSelectionChange={(e) =>
                      handleFormSelectionChange(e, "type")
                    }
                  >
                    {(item) => {
                      return (
                        <AutocompleteItem key={item.value}>
                          {item.value}
                        </AutocompleteItem>
                      )
                    }}
                  </Autocomplete>
                  <Autocomplete
                    isRequired
                    size="sm"
                    label="Supply Type"
                    placeholder="--Select--"
                    className="max-w-23"
                    name="supplyType"
                    isVirtualized
                    isClearable={false}
                    value={formData.supplyType}
                    selectedKey={formData.supplyType}
                    onChange={handleFormSelectionChange}
                    onSelectionChange={(e) =>
                      handleFormSelectionChange(e, "supplyType")
                    }
                    defaultItems={SUPPLY_TYPE ? SUPPLY_TYPE : []}
                  >
                    {(item) => {
                      return (
                        <AutocompleteItem key={item.s_type}>
                          {item.s_type}
                        </AutocompleteItem>
                      )
                    }}
                  </Autocomplete>
                </div>
                <div className="flex  items-center gap-2 mb-5">
                  <Autocomplete
                    isRequired
                    id="noteType"
                    size="sm"
                    label="Note Type"
                    placeholder="--Select--"
                    className="max-w-23"
                    name="noteType"
                    color="primary"
                    isVirtualized
                    value={formData.noteType}
                    isClearable={false}
                    onSelectionChange={(e) =>
                      handleFormSelectionChange(e, "noteType")
                    }
                    selectedKey={formData.noteType}
                    defaultItems={NOTE_TYPE ? NOTE_TYPE : []}
                  >
                    {(item) => {
                      return (
                        <AutocompleteItem key={item.n_type}>
                          {item.n_type}
                        </AutocompleteItem>
                      )
                    }}
                  </Autocomplete>
                  <Input
                    size="sm"

                    isRequired
                    type="text"
                    label="Vou No."
                    defaultValue=""
                    className="max-w-23"
                    name="vouNo"
                    color="warning"
                    isReadOnly
                    value={formData.vouNo}
                    onChange={handleFormChange}
                  ></Input>
                </div>
                <div className="flex  items-center gap-2 mb-5">
                  <LocalizationProvider isRequired dateAdapter={AdapterDayjs}>
                    <DatePicker

                      isRequired
                      name="docDate"
                      label={"DOC Date"}
                      views={["day", "month", "year"]}
                      format="DD/MM/YYYY"
                      value={
                        formData.docDate
                          ? dayjs(formData.docDate)
                          : formData.docDate
                      }
                      onChange={(newValue) => {
                        setFormData((prev) => {
                          return { ...prev, docDate: dayjs(newValue).format("YYYY-MM-DD") }
                        })
                      }}
                      className="max-w-23"
                    />
                  </LocalizationProvider>
                  <Input
                    isRequired
                    size="sm"
                    type="text"
                    label="Note No."
                    defaultValue=""
                    name="noteNo"
                    value={formData.noteNo}
                    onChange={handleFormChange}
                    className="max-w-50"
                  ></Input>
                </div>
                <div className="flex  items-center gap-2 mb-5">
                  <Input
                    size="sm"
                    type="text"
                    label="Party's Doc. No."
                    name="partyDocNo"
                    value={formData.partyDocNo}
                    onChange={handleFormChange}
                    defaultValue=""
                    className="max-w-23"
                  ></Input>
                  <Autocomplete
                    isRequired
                    id="tradeType"
                    size="sm"
                    label="Trade Type"
                    placeholder="--Select--"
                    className="max-w-23"
                    name="tradeType"
                    isClearable={false}
                    color="primary"
                    value={formData.tradeType}
                    onSelectionChange={(e) =>
                      handleFormSelectionChange(e, "tradeType")
                    }

                    selectedKey={formData.tradeType}
                    defaultItems={TRADE_TYPE ? TRADE_TYPE : []}
                  >
                    {(item) => {
                      return (
                        <AutocompleteItem key={item.t_type} value={item.t_type}>
                          {item.t_type}
                        </AutocompleteItem>
                      )
                    }}
                  </Autocomplete>
                </div>
                <div className={` ${isMobile ? 'flex-wrap' : ''} flex  items-center gap-2 mb-5`}>

                  <Autocomplete
                    isRequired
                    size="sm"
                    id="creditAc"
                    label="Credit Ac."
                    eventResizeFeature={true}
                    selectionMode="single"
                    showScrollIndicators={true}
                    placeholder="--Select--"
                    className="max-w-23"
                    isVirtualized
                    isClearable={false}
                    color="success"
                    isLoading={isLoading}
                    defaultItems={
                      masterData && masterData.accountMaster
                        ? masterData.accountMaster
                        : []
                    }
                    onSelectionChange={(e) =>
                      handleAutoCompleteChanged(e, "creditAc")
                    }
                    selectedKey={formData.creditAc}
                  >
                    {(item) => (
                      <AutocompleteItem

                        key={item.Party_Id}
                      >
                        {item.Party_Name}
                      </AutocompleteItem>
                    )}
                  </Autocomplete>
                  <Autocomplete
                    isVirtualized
                    isRequired
                    size="sm"
                    id="debitac"
                    label="Debit Ac."
                    eventResizeFeature={false}
                    selectionMode="single"
                    showScrollIndicators={true}
                    placeholder="--Select--"
                    className="max-w-23"
                    isClearable={false}
                    isLoading={isLoading}
                    color="danger"
                    defaultItems={
                      masterData && masterData.accountMaster
                        ? masterData.accountMaster
                        : []
                    }
                    onSelectionChange={(e) =>
                      handleAutoCompleteChanged(e, "debitAc")
                    }
                    selectedKey={formData.debitAc}
                  >
                    {(item) => (
                      <AutocompleteItem

                        key={item.Party_Id}
                      >
                        {item.Party_Name}
                      </AutocompleteItem>
                    )}
                  </Autocomplete>
                </div>
              </div>
              {/* end  credit/debit form section */}
              {/* dynamic grid section */}
              <div >
                <Button size="sm" color="primary" onPress={handleAddRow}>
                  Add Item
                </Button>

                {rows && rows?.length > 0 ? (
                  <div style={{ height: 50 + Number(rows.length * 51) }}>
                    <DataGrid
                      rows={rows}
                      columns={columns}
                      editMode="row"
                      hideFooterPagination={true}
                      hideFooter={true}
                      columnHeaderHeight={35}
                      rowHeight={50}
                      disableColumnSorting={true}
                      disableColumnMenu={true}
                    />
                  </div>
                ) : (
                  ""
                )}

              </div>

              {/* /end dynamic grid section */}
              {/* /tax calculation section */}
              <div>
                <div className="flex  items-top gap-2 mt-7">
                  <Input
                    size="sm"
                    type="number"
                    label="Gross Amount"
                    labelPlacement="outside"
                    value={gross_Amount}
                    className="max-w-25"
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  />

                  <Input
                    size="sm"
                    type="number"
                    label="Discount"
                    labelPlacement="outside"
                    value={total_disc}
                    className="max-w-25"
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  />
                  <Input
                    size="sm"
                    type="text"
                    label="Remarks"
                    labelPlacement="outside"
                    placeholder="Remarks"
                    className="max-w-25"
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleFormChange}
                  />
                </div>
                <div className="flex  items-top gap-2 mt-3">
                  <Input
                    size="sm"
                    type="number"
                    label={!isStPerDisable ? "CGST Tax" : "IGST Tax"}
                    labelPlacement="outside"
                    value={total_GSTtax}
                    className="max-w-25"
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  />
                  <Input
                    size="sm"
                    type="number"
                    label="SGST Tax"
                    labelPlacement="outside"
                    value={!isStPerDisable ? total_SGSTtax : "0"}
                    className="max-w-25"
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  />
                  <Input
                    size="sm"
                    type="number"
                    label="Total Tax"
                    labelPlacement="outside"
                    value={total_Tax}
                    className="max-w-25 "
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  />
                </div>
                <div className="flex  items-top gap-2 mt-3">
                  <Input
                    size="sm"
                    type="text"
                    label="TDS %"
                    labelPlacement="outside"
                    className="max-w-25"
                    value={setTdsPer}
                    onChange={(e) => { funValidateNoInput(e.target.value) ? setSetTdsPer(e.target.value) : setSetTdsPer(0) }}
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  />
                  <Input
                    size="sm"
                    type="number"
                    label="TDS Amount"
                    labelPlacement="outside"
                    className="max-w-25"
                    disabled={true}
                    value={total_TdsAmt}
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  />
                  <Autocomplete
                    size="sm"
                    id="tdsAc"
                    label="TDS Ac."
                    isVirtualized
                    labelPlacement="outside"
                    placeholder="--Select--"
                    className="max-w-25"
                    isClearable={false}
                    defaultItems={
                      masterData && masterData.tdsMaster
                        ? masterData.tdsMaster
                        : []
                    }
                    onSelectionChange={(e) =>
                      handleFormSelectionChange(e, "tdsAc")
                    }
                    selectedKey={formData.tdsAc}
                  >
                    {(item) => (
                      <AutocompleteItem key={item.Party_Id}>
                        {item.Party_Name}
                      </AutocompleteItem>
                    )}
                  </Autocomplete>
                </div>
                <div className="flex  items-top gap-2 mt-3">
                  <Input
                    size="sm"
                    type="number"
                    label="Net Amount"
                    labelPlacement="outside"
                    value={net_Amount}
                    className="max-w-25"
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  />
                  <Input
                    size="sm"
                    type="text"
                    label="TCS %"
                    labelPlacement="outside"
                    className="max-w-25"
                    value={setTcsPer}
                    onChange={(e) => { funValidateNoInput(e.target.value) ? setSetTcsPer(e.target.value) : setSetTcsPer(0) }}
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  />
                  <Input
                    size="sm"
                    type="number"
                    label="TCS Amount"
                    labelPlacement="outside"
                    className="max-w-25"
                    disabled={true}
                    value={total_TcsAmt}
                    startContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-default-400 text-small">₹</span>
                      </div>
                    }
                  />
                </div>
              </div>
              {/* /end tax calculation section */}
              <div></div>
            </CardBody>

            <CardFooter className="flex gap-4 justify-center">
              <Button color="primary" variant="shadow" type="submit" isLoading={isPending}>
                Submit
              </Button>
              <Button
                color="danger"
                variant="shadow"
                size="md"
                onPress={handleClickPrev}

              >
                Cancel
              </Button>
            </CardFooter>
          </form>
        </Card>
      </MainContainer>
    </div>
  )
}

export default CreditDebitNote
